<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("data.title") }}</h5>
    <div>
      <vue-element-loading :active="isLoading" spinner="spinner" />
      <table class="table is-fullwidth is-hoverable">
        <thead>
          <tr>
            <th>{{ $t("devices.deviceLocate") }}</th>
            <th>{{ $t("devices.deviceId") }}</th>
            <th>{{ $t("devices.deviceType") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, deviceId) in deviceList" :key="deviceId">
            <td>
              <router-link
                :to="{
                  name: 'dataView',
                  params: {
                    projectId: item.projectId,
                    deviceId: item.deviceId,
                  },
                }"
              >
                {{ item.deviceLocate }}
              </router-link>
            </td>
            <td>{{ item.deviceId }}</td>
            <td>{{ item.deviceType }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb";
import imsr from "@/imsr-api";
import { ref } from "@vue/reactivity";
import VueElementLoading from "vue-element-loading";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    VueElementLoading,
    Breadcrumb,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const deviceList = ref();
    const breadcrumb = ref([
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: route.params.projectId },
        },
      },
      { title: "Data", path: "#", isActive: true },
    ]);
    const isLoading = ref(false);

    const getList = async () => {
      try {
        isLoading.value = true;
        const params = {
          tenantId: store.getters.tenantId,
          projectId: route.params.projectId,
        };
        deviceList.value = await imsr.imsrGetApi("/devices/list", params);
        isLoading.value = false;
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };
    getList();

    return {
      deviceList,
      breadcrumb,
      isLoading,
    };
  },
};
</script>
S
